import { DxHeight } from "devextreme-vue/cjs/chart";
import notify from "devextreme/ui/notify";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useToaster = defineStore("toast", () => {
  function error(text) {
    toast(text, 'error');
  }

  function success(text) {
    toast(text, 'success');
  }

  function toast(text, type) {
    notify({
        message: text,
        height: 45,
        width: 250,
        type: type,
        displayTime: 3000
      },{
        position: 'top center'
      }
    );
  }

  return {
    error,
    success,
  };
});
